import React from 'react'
import { TypographyStylesProvider } from '@mantine/core'

type Props = {
  html: string
  style?: React.CSSProperties
}

export default function HtmlContent(props: Props) {
  const { html, style } = props

  if (!html) return null

  return (
    <TypographyStylesProvider>
      <div dangerouslySetInnerHTML={{ __html: html }} style={style} />
    </TypographyStylesProvider>
  )
}
